// extracted by mini-css-extract-plugin
module.exports = {"courseStatus":"components_courseStatus__1q8hd","courseStatusLive":"components_courseStatusLive__3DOBB","courseStatusDraft":"components_courseStatusDraft__1gxw9"};